import { httpRequest } from "../../http";
import { TagGroup } from "@models/tagGroup.model";

export class CommandGetTagGroups {
    /**
     * Tag groups, optionally narrowed to one organization.
     *
     * The catalog's filter panel asks for ALL of them (MPN-1579). Tag groups carry an
     * organization and belong to the provider, so scoping this to whichever catalog was on
     * screen left the Client Catalog tab with an empty panel and nothing to filter by.
     * Checked on production: scoped returns 6 groups, unscoped 9 -- the extra three are
     * Target Action, Customization Level and Date, the same shared vocabulary.
     */
    async run(organizationId?: number, signal?: AbortSignal): Promise<TagGroup[]> {
        const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/core/tag_groups/`;
        const url = organizationId != null ? `${base}?organization_id=${organizationId}` : base;
        try {
            const response = await httpRequest<TagGroup[]>(url, { method: "GET", signal });
            return response ?? [];
        } catch (error) {
            if (signal?.aborted) throw error;
            console.error("Error fetching tag groups:", error);
            throw error;
        }
    }
}
